import { render, staticRenderFns } from "./FeaturesDetail.vue?vue&type=template&id=0eada032&scoped=true&"
import script from "./FeaturesDetail.vue?vue&type=script&lang=js&"
export * from "./FeaturesDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesDetail.vue?vue&type=style&index=0&id=0eada032&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eada032",
  null
  
)

export default component.exports